module.exports = __webpack_public_path__ + "img/budget.a28ba0c8.svg";